import React, { Suspense, useEffect } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { LocalAccessRoles } from '@shared/config';
import { STREAMS_CATEGORY_PATH, StreamsCategoryParamValues } from 'application/pages/StreamPage';
import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectHasActiveContractMigration } from 'application/store';

import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

export const CONTRACT_MIGRATION_PAGE_PATH = '/accept-oferta';

const Renderer = React.lazy(() => import('./renderer'));

const ContractMigrationPageWrapper: IApplicationPage = () => {
  const navigate = useNavigate();
  const hasActiveContractMigration = useAppSelector(selectHasActiveContractMigration);

  useEffect(() => {
    if (!hasActiveContractMigration) {
      navigate(
        RouterUtils.generatePath(STREAMS_CATEGORY_PATH, {
          category: StreamsCategoryParamValues.RECOMMENDED,
        }),
        {
          replace: true,
        }
      );
    }
  }, [hasActiveContractMigration]);

  return (
    <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
      <Renderer />
    </Suspense>
  );
};

ContractMigrationPageWrapper.config = {
  routes: [{ path: CONTRACT_MIGRATION_PAGE_PATH }],
  access: [LocalAccessRoles.AUTHORIZED],
};

export default ContractMigrationPageWrapper;
